module.exports = __webpack_public_path__ + "static/media/loader_spin_greenBig.84ea8dde.gif";